<template>
    <div style="min-height: 100vh;background: #F9F9FF;overflow-x: hidden;width: 100%">
        <div class="container">

<!--            <a-form-model layout="inline" ref="fm" :model="form" :label-col="{span:7}" :wrapper-col="{ span: 16 }" v-if="false">-->
<!--                <div v-for="(item,index) in form.data" :key="index">-->
<!--                    <a-form-model-item-->
<!--                            :prop="'data.'+index+'.name'"-->
<!--                            :rules="[{-->
<!--                                 required: true,-->
<!--                                  message: '不能为空', trigger: 'blur',name: item.name-->
<!--                                  }]"-->
<!--                    >-->
<!--                        <a-input-->
<!--                                v-model="item.name"-->
<!--                                style="width: 150px;"-->
<!--                        />-->
<!--                    </a-form-model-item>-->

<!--                    <a-form-model-item-->
<!--                            :prop="'data.'+index+'.age'"-->
<!--                            :rules="[{type: 'number',-->
<!--                                 required: true,-->
<!--                                  message: '不能为空', trigger: 'blur',name: item.age-->
<!--                                  }]"-->
<!--                    >-->
<!--                        <a-input-number-->
<!--                                v-model="item.age"-->
<!--                                style="width: 150px;"-->
<!--                        />-->
<!--                    </a-form-model-item>-->

<!--                    <a-form-model-item-->
<!--                            :prop="'data.'+index+'.sex'"-->
<!--                            :rules="[{-->
<!--                                 required: true,-->
<!--                                  message: '不能为空', trigger: 'blur',name: item.sex-->
<!--                                  }]"-->
<!--                    >-->
<!--                        <a-input-->
<!--                                v-model="item.sex"-->
<!--                                style="width: 150px;"-->
<!--                        />-->
<!--                    </a-form-model-item>-->
<!--                </div>-->

<!--                <div  class="mt-5" style="text-align: center;">-->
<!--                    <a-button type="primary"  @click="onSubmit">提交</a-button>-->
<!--                </div>-->
<!--            </a-form-model>-->
<!--            -->

            <div class="container" style="margin-top: -43px;min-height: calc(100vh - 56px - 193px + 32px - 77px);">
                <a-tabs class="t1" type="card" @change='tabChange'>
                    <a-tab-pane key="1" tab="项目信息">
                        项目信息
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="包组信息">
                        包组信息
                    </a-tab-pane>
                    <a-tab-pane key="3" tab="投标保证金">
                        投标保证金
                    </a-tab-pane>
                    <a-tab-pane key="4" tab="项目答疑">
                        项目答疑
                    </a-tab-pane>
                    <a-tab-pane key="5" tab="项目竞价">
                        项目竞价
                    </a-tab-pane>
                    <a-tab-pane key="8" tab="竞价结果">
                        竞价结果
                    </a-tab-pane>
                    <a-tab-pane key="6" tab="成交通知书">
                        成交通知书
                    </a-tab-pane>
                    <a-tab-pane key="7" tab="合同备案">
                        合同备案
                    </a-tab-pane>
                    <a-tab-pane key="9" tab="项目异议" v-if="false">
                        项目异议
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import 'vue-area-linkage/dist/index.css'
    import MVCountDown from '@/components/MVCountDown/MVCountDown'
    import UploadSelector from '@/components/selector/UploadSelector'
    import moment from "moment"
    import MySlot from './MySlot'
    import 'vue-area-linkage/dist/index.css'
    import TinyMCE from '@/components/Editor/TinyMCE'


    export default {
        components: {
            MVCountDown,
            UploadSelector,
            MySlot,
            TinyMCE
        },
        created() {
            this.initRandom()
        },
        watch: {
            projectRandom: {
                immediate: false,
                handler(newValue,oldValue) {
                    if (newValue !== oldValue) {
                        // this.initProjectInfo()
                        this.initAnnounceList()
                        // this.countDown()
                    }
                }
            }
        },
        data() {
            return {
                projectRandom: '',
                packRandom: '',
                bondRandom: '',
                replyRandom: '',
                serviceRandom: '',
                resultRandom: '',
                contractRandom: '',
                dissentRandom: ''
            }
        },
        methods: {
            initRandom() {
                this.projectRandom = Math.random()+ ""
                this.packRandom = Math.random()+ ""
                this.bondRandom = Math.random()+ ""
                this.replyRandom =  Math.random()+ ""
                this.serviceRandom = Math.random()+ ""
                this.contractRandom =  Math.random()+ ""
                this.dissentRandom =  Math.random()+ ""
                this.resultRandom = Math.random()
            },
            onSubmit() {
                debugger
                let that = this
                this.$refs.fm.validate((err) => {
                    debugger
                    if (err) {
                        var paramModel = {
                            cmtList: that.form.data
                        }
                        console.log(paramModel)
                    }
                });
            },
            add() {
              this.list.push({count:10,name:Math.random()+""})
            },
            changeValue(val) {
                return val
            },
            del(index) {
                this.list.splice(index,1)
            },
            tabChange(activeKey) {
                switch (activeKey) {
                    case '1':
                        this.projectRandom = Math.random()+ ""
                        break;
                    case '2':
                        this.packRandom = Math.random()+ ""
                        break;
                    case '3':
                        this.bondRandom = Math.random()+ ""
                        break;
                    case '4':
                        this.replyRandom =  Math.random()+ ""
                        break;
                    case '6':
                        this.serviceRandom = Math.random()+ ""
                        break;
                    case '7':
                        this.contractRandom =  Math.random()+ ""
                        break;
                    case '8':
                        this.resultRandom =  Math.random()+ ""
                        break;
                }
            },
        },
        computed: {
            totalMoney:function () {
                var c = 0
                for (let i = 0; i < this.list.length; i++) {
                    c += parseInt(this.list[i].fee)
                }
                return this.singlePrice * c
            },
            ttt:function () {
                return this.tt
            }
        },
        watch: {
            // singlePrice(newValue,oldValue) {
            //     if (oldValue != newValue) {
            //         console.log("oldValue   " + oldValue)
            //         console.log("newValue   " + newValue)
            //
            //     }
            // }
            singlePrice(value) {
                console.log(value)
                if(value > 200) {
                    this.$message.info("不能超过200")
                }else if (value < 0) {
                    this.$message.info("不能小于0")
                }
            }
        }
    };
</script>
<style lang="less" scoped>

    .head-bg {
        position: relative;
    }

    .head-bg div {
        position: absolute;
        top: 0;
        color: #fff;
        font-size: 36px;
        width: 100%;
        text-align: center;
        line-height: 60px;
        height: 60px;
        margin-top: 42px;
    }

    .head-bg div span {
        margin: 0 2px;
        display: inline-block;
        vertical-align: top;
    }

    .number {
        background: rgba(255, 22, 0, 0.35);
        font-size: 45px;
        padding: 0 12px;
    }

    .card-container /deep/ .ant-tabs-bar {
        margin: 0;
        border: none;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-tab {
        border: none;
        padding-bottom: 0;
        line-height: 44px;
        border-radius: 0;
        color: #fff;
        background: rgba(255, 255, 255, 0.4);
        font-size: 16px;
        flex: 1;
        text-align: center;
        height: 44px;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-tab:nth-last-child(1) {
        margin-right: 0;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-tab-active {
        color: #1890ff;
        background: #fff;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-nav-container {
        height: 44px;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card .ant-card-bordered {
        border: none;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-nav {
        display: block;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-nav > div {
        display: flex;
    }

    /deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar {
        margin-bottom: 0;
        border-bottom: none;
    }

    .table-a {
        table-layout: fixed;
    }

    .table-a td {
        vertical-align: top;
        padding: 8px 0;
        font-size: 14px;
        font-weight: bold;
    }

    .table-a th {
        text-align: justify;
        text-align-last: justify;
        color: #8c8c8c;
        font-weight: 500;
        padding: 8px 0;
    }

    .contact {
        font-size: 0;
        margin: 0 -12px;
    }

    .contact .col {
        width: 50%;
        padding: 12px;
        box-sizing: border-box;
        font-size: 14px;
        display: inline-block;
    }

    .contact .col .title {
        background: #F3E4D8;
        padding: 12px;
    }

    .contact .col .info {
        border: 1px solid #e6e6e6;
        padding: 12px;
    }

    /deep/ .notice .p-0 .ant-card-body {
        padding: 0;
    }

    /deep/ .notice .ant-tabs-nav .ant-tabs-tab {
        font-size: 20px;
        font-weight: bold;
    }

    /deep/ .notice .ant-tabs-bar {
        margin-bottom: 0;
        border-bottom: 3px solid #e6e6e6;
    }

    /deep/ .ant-table-thead > tr > th, /deep/ .ant-table-tbody > tr > td {
        background: #fff;
    }

    .fx-form-view th {
        border: 1px solid #e6e6e6;
        background-color: #f7f7f7;
    }

    .fx-form-view td {
        border: 1px solid #e6e6e6;
        width: 400px;
    }

    .fx-form-view {
        table-layout: auto;
    }
</style>
